export default __webpack_public_path__ + "media/flags/ci-d14b72eb.svg";